/*
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-06-04 17:09:46
 * @LastEditors: game.pluto.com 66291979@qq.com
 * @LastEditTime: 2024-09-11 11:34:02
 * @FilePath: /lobby/src/server/socket.js
 * @Description: socket version: 1.4.8  https://github.com/socketio/socket.io-client/tree/1.4.8
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
// src/utils/socket.js
// import { useUserStore } from '@/stores/user'
// import io from 'socket.io-client'

import { BUS } from '@/event/EventCenter'
import { useUserStore } from '@/stores/user'

// 创建一个单例，避免在多个组件中创建多个连接
let socket

// 封装socket连接
class SocketService {
  constructor(url) {
    if (!socket) {
      setTimeout(() => {
        const user = useUserStore()
        socket = window.io(url, {
          transports: ['websocket', 'polling'],
          query: {
            token: user.token
          }
        })
        // 这里可以添加一些通用的socket事件监听器
        socket.on('recharge', (data) => {
          console.log('Received data from server:', data)
          // Received data from server: {"orderId":2019292053770241,"status":3,"amount":"30"}
          window.bridge.$emit(BUS.PUSH_NOTIFICATION, JSON.parse(data))
        })
        //游戏中刷新平台balance
        socket.on('balance', (data) => {
          console.log('balance data from server:', data)
          // Received data from server: {"total":123123,"currency":"ETB"}
          window.bridge.$emit(BUS.UPDATE_BALANCE)
        })
        socket.on('connect', () => {
          console.log('成功连接（包括重新连接）')
          if (user.isLogin) {
            this.emit('login', user.token)
          }
          // this.emit('login', 'b955b335d08d4edb9c101cb770007e977f42b3e7cd5840ab958c81cc5295d791')
        })
        socket.on('disconnect', () => {
          console.log('断开连接')
        })
        socket.on('error', (err) => {
          console.log('连接错误', err)
        })
        socket.on('reconnect', (count) => {
          console.log('成功重新连接，第【', count, '】次')
        })
        socket.on('reconnect_attempt', () => {
          console.log('尝试重新连接')
        })
        socket.on('reconnecting', (count) => {
          console.log('尝试重新连接，第【', count, '】次')
        })
        socket.on('reconnect_error', () => {
          console.log('重新连接尝试错')
        })
        socket.on('reconnect_failed', () => {
          console.log('无法在规定的重新连接尝试次数内重新连接')
        })
      }, 3000)
      // 添加其他通用事件监听...
      // connect. Fired upon a connection including a successful reconnection.
      // error. Fired upon a connection error Parameters: Object error data
      // disconnect. Fired upon a disconnection.
      // reconnect. Fired upon a successful reconnection. Parameters: Number reconnection attempt number
      // reconnect_attempt. Fired upon an attempt to reconnect.
      // reconnecting. Fired upon an attempt to reconnect. Parameters: Number reconnection attempt number
      // reconnect_error. Fired upon a reconnection attempt error. Parameters: Object error object
      // reconnect_failed. Fired when couldn't reconnect within reconnectionAttempts

      // connect. 在成功连接（包括重新连接）时触发。
      // error. 在连接错误时触发 参数: Object 错误数据
      // disconnect. 在断开连接时触发。
      // reconnect. 在成功重新连接时触发 参数: Number 重新连接尝试次数
      // reconnect_attempt. 在尝试重新连接时触发。
      // reconnecting. 在尝试重新连接时触发 参数: Number 重新连接尝试次数
      // reconnect_error. 在重新连接尝试错误时触发 参数: Object 错误对象
      // reconnect_failed. 在无法在规定的重新连接尝试次数内重新连接时触发
    }
  }

  // 发送消息到服务器
  emit(event, data) {
    console.log('发消息【', event, '】')
    if (socket && socket.connected) {
      socket.emit(event, data)
      console.log('【', event, '】已发送')
    } else {
      console.log('已断链【', event, '】未发送')
    }
  }

  // 监听服务器发送的事件
  on(event, callback) {
    socket.on(event, callback)
  }

  // 移除服务器发送的事件监听
  off(event, callback) {
    socket.off(event, callback)
  }

  // 断开连接
  disconnect() {
    if (socket && socket.connected) {
      socket.disconnect()
    }
  }
}

// 导出单例
export default new SocketService(import.meta.env.VITE_PUSH_API_URL) // dev
// export default new SocketService('https://push-api.megalake.games') // dev
// export default new SocketService('https://ph-api.vivagameclub.com') // pro
